<template>
  <div class="alert alert-primary alert-dismissible fade show" role="alert">
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="alert-heading">Thank you for signing up!</h4>
    <div>A verification email has been sent to your email address. Your notes will not sync until your email address has been verified.</div>
    <hr class="my-2" />
    <div v-if="!verificationEmailSent">
      Haven't received your email?
      <a
        class="badge badge-request badge-secondary"
        @click="requestNewEmail"
      >Click here to request a new verification email</a>
    </div>
    <div v-else>A new verification email has beent sent. Check your inbox and get started using Contexted!</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      verificationEmailSent: false
    }
  },
  methods: {
    requestNewEmail() {
      this.$store.dispatch('sendVerificationEmail')
      this.verificationEmailSent = true
    }
  }
}
</script>
<style scoped lang="scss">
.badge-request {
  color: $white!important;
}
</style>
